// LLM generated - Model Claude 4 Sonnet
import { PrimaryWhale } from '~/components/shared/Logos/SplashLogo';

type BrandLogoProps = {
  size: number;
  className?: string;
};

export function BrandLogo({ size, className }: BrandLogoProps) {
  return <PrimaryWhale size={size} className={className} />;
}
